<template>
  <div id="departments">
    <!-- <div style="height: 6px;"></div>
    <div style="padding: 6px;">
      <span style="font-size:16px;padding-left: 14px;">
        <i style="display: inline-block; width: 18px;height: 18px;position: relative;top: 3px;">
          <img style="width: 100%;height: 100%;" src="@/assets/tag.png" alt="">
        </i>
        {{ $t('message.list.associateTheSameForm') }}
      </span>
    </div> -->

    <div style="margin-top: 10px;margin-right: 20px;">
      <el-button class="btn btn1" icon="el-icon-circle-plus-outline" @click="searchAddRel = true"
        :disabled="!addTableListPriv || !workFlowStatus"
        :class="!addTableListPriv || !workFlowStatus ? 'btnDisable' : ''">{{ $t('message.button.add') }}
      </el-button>
      <el-button class="btn btn2" icon="el-icon-delete" @click="removeCheckbox"
        :disabled="!removeTableListPriv || !workFlowStatus"
        :class="!removeTableListPriv || !workFlowStatus ? 'btnDisable' : ''">{{ $t('message.button.delete') }}
      </el-button>
    </div>

    <div style="padding: 10px 20px;">
      <!-- 表格区域 -->
      <vxe-grid ref='xGrid' v-bind="gridOptions" @checkbox-change="checkboxChangeEvent"
        @checkbox-all="checkboxChangeEvent">
        <template #bottom>
          <div class="alert-message">
            <span class="alert-message-content">
              <div>{{ $t('message.title.Checked') + selectRecords.length + $t('message.title.resultsNums') }} </div>
            </span>
          </div>
        </template>
      </vxe-grid>
    </div>
    <el-dialog class="searchAddBomList" v-if='searchAddRel' :title="$t('message.title.add')"
      :visible.sync="searchAddRel" :close-on-click-modal="false" :close-on-press-escape="false">
      <SearchQuality @listDbClick="addList"></SearchQuality>
    </el-dialog>
  </div>
</template>
<script>
import SearchQuality from '@/components/searchQuality.vue'; //引进菜单模板
import RelSearchAddNext from '@/components/relSearchAdd.vue';
import axios from "axios";
export default {
  data() {
    return {
      searchAddRel: false, //添加窗口开关
      version: "",
      selectRecords: [],
      totalRecords: "",
      gridOptions: {
        keepSource: true,
        resizable: true,
        border: true,
        stripe: true,
        highlightHoverRow: true,
        highlightCurrentRow: true,
        showHeaderOverflow: true,
        showOverflow: true,
        autoResize: true,
        rowId: 'id',
        height: "530",
        size: "small",
        columns: [],
        data: [],
        treeConfig: {
          lazy: true,
          children: 'children',
          hasChild: 'hasChildren',
          loadMethod: this.loadChildrenMethod
        },
        editConfig: {
          trigger: 'dblclick',
          mode: 'cell',
          showIcon: false,
          activeMethod: this.activeRowMethod,
          showStatus: true,
        },
        sortConfig: {
          trigger: 'cell'
        },
      },
      workFlowStatus: true,//变更工作流状态
      loading: true,
      cols: [], //表头
      rols: [], //表体所有内容
      rols_text: [], //表体显示内容
      get_change_info: "", //父组件传来的值
      //权限
      addTableListPriv: false,
      removeTableListPriv: false,
    }
  },
  mounted() { },
  components: {
    SearchQuality,
    RelSearchAddNext
  },
  methods: {
    checkboxChangeEvent({ records }) {
      const $grid = this.$refs.xGrid;
      this.selectRecords = records;
    },

    showDetailEvent(row) {
      const obj = {
        id: row.itemId,
        classId: row.itemClassId,
        subClassId: row.itemSubClassId,
        title: row[0]
      };
      this.getLink(obj);
      this.$store.commit("setPageRefresh");
    },

    removeCheckbox() { //删除
      var removeRow = this.$refs.xGrid.getCheckboxRecords();
      if (removeRow.length == 0) {
        return false
      } else {
        let relationshipMapVo = {
          qualityObjId: {
            ...this.$store.state.objectId,
            version: 0,
          },
          deleteQuality: [],
          tableId: 42,
        };
        relationshipMapVo.deleteQuality = removeRow.map(i => ({
          id: i.rowId,
        })
        )
        axios.post('/pqm/quality/deleteTable', relationshipMapVo).then(res => {
          if (res.data.code == 200) {
            this.$message({
              message: res.data.message,
              type: 'success'
            });
            this.getRelInfo();
          }
        })
          .catch(function (error) {
            console.log(error);
          });
      }
    },

    addList(row) { //添加
      let relationshipMapVo = {
        changeObjId: {
          id: 0,
          classId: 0,
          subClassId: 0,
          version: 0,
        },
        qualityObjId: {
          ...this.$store.state.objectId,
          version: 0,
        },
        insertQuality: [],
        tableId: 42,
      };
      relationshipMapVo.insertQuality = row.map(i => ({
        qualityId: this.$store.state.objectId.id,
        qualityRelevantId: i.itemId,
      })
      )
      axios.post('/pqm/quality/saveTable', relationshipMapVo)
        .then(res => {
          console.log(res);
          if (res.data.code == 200) {
            this.$message({
              message: res.data.message,
              type: 'success'
            });
          };
          this.getRelInfo();
        })
        .catch();
    },

    activeRowMethod({ row }) {
      return !row.disable
    },

    getRelInfo() {
      this.$emit('refreshTab');
      var change_info = this.$store.state.change_info;
      if (this.get_change_info == "") {
        change_info = this.$store.state.change_info;
      } else {
        change_info = this.get_change_info;
      };
      var obj_get = { //获取change
        ... this.$store.state.objectId,
        ...change_info,
        tableId: 42
      };
      var loadTableUrl = `/pqm/quality/loadTable${this.params(obj_get)}`;
      axios.get(loadTableUrl).then(res => {
        this.gridOptions.columns = this.getNewTableTitleData(res.data);
        this.cols = res.data.object.table.columnInfo.ids;
        this.rols_text = this.getNewTableContentData(res.data);
        this.$refs.xGrid.loadData(this.rols_text);
        this.totalRecords = res.data.object.table.totalRecords;
        this.version = res.data.object.table.version;
        this.selectRecords = [];
      })
    },

    loadUserPriv() {
      var priv_ = this.getUserContextPriv();
      let subClass_Id = this.$store.state.objectId.subClassId;
      for (let i = 0; i < priv_.length; i++) {
        if (priv_[i].classId == subClass_Id) {
          if (priv_[i].type == 3) {
            this.addTableListPriv = true;
          };
          if (priv_[i].type == 4) {
            this.removeTableListPriv = true;
          };
        }
      };
      let isSupAdmin = this.$store.state.isSuperAdmin;
      if (isSupAdmin) {
        this.addTableListPriv = true;
        this.removeTableListPriv = true;
      };
    },
  },
  created() {
    this.loadUserPriv();
    this.getRelInfo();
    setTimeout(() => {
      this.loading = false;
    }, 500);
  },
  computed: {
    loadWorkFlowStatus() {
      return this.$store.state.changeWorkflowStatus;
    },
  },
  props: ['changeValue', 'relUrl', 'type'],
  watch: {
    changeValue: function (value) {
      this.get_change_info = value;
      this.getRelInfo();
    },
    loadWorkFlowStatus: {
      handler(val) {
        const baseId = this.$store.state.objectId.classId.toString().substr(0, 3);
        if (baseId == 401) {
          this.workFlowStatus = !([3, 4].includes(val))
        } else {
          this.workFlowStatus = true
        }
        console.log({ baseId, val, w: this.workFlowStatus });
      },
      deep: true,
      immediate: true,
    },
  }
};
</script>

<style>
.RelSearchAddBomList .el-dialog__body {
  padding: 0 20px 20px 20px !important;
}

.el-table th.gutter {
  display: table-cell !important;
}

.link_ {
  color: #4b92ff;
  cursor: pointer;
}

.link_:hover {
  color: #4b92ff;
  cursor: pointer;
  border-bottom: 1px solid #4b92ff;
}

.mytable-style .vxe-body--column.col-red {
  text-decoration: line-through;
  color: red;
}

.mytable-style .vxe-body--column.col-red span {
  color: #000;
}

.mytable-style .vxe-body--column.col-red-text {
  color: red;
}

.mytable-style .vxe-body--column.col-red-text span {
  color: red;
}
</style>

<style scoped>
.line-1 {
  height: 6px;
  background: #ebebeb;
}

.content-title {
  padding: 0;
  margin: 0;
  overflow: hidden;
  background-size: 100% 100%;
  height: 40px;
  margin-left: 20px;
}

.content-title li {
  float: left;
  padding: 8px 8px 8px 8px;
  font-size: 14px;
  cursor: pointer;
  margin-right: 18px;
}

.content-title li:hover {
  border-bottom: 3px solid #4b92ff;
  color: #4b92ff;
}

.content-title .active {
  border-bottom: 3px solid #4b92ff;
  color: #4b92ff;
}
</style>